var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6766_20289)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9052 16.1123C12.3682 16.1123 12.8122 16.2962 13.1396 16.6236C13.467 16.951 13.651 17.3951 13.651 17.8581V20.4958H10.3442V17.6732C10.3442 17.4682 10.3846 17.2652 10.4631 17.0759C10.5415 16.8865 10.6565 16.7144 10.8014 16.5695C10.9464 16.4245 11.1185 16.3095 11.3078 16.2311C11.4972 16.1527 11.7002 16.1123 11.9052 16.1123Z",
    stroke: "#7C4095",
    strokeWidth: 1.20362,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.98412 3.47363H15.707C16.0676 3.47363 16.4134 3.61688 16.6684 3.87188C16.9234 4.12687 17.0667 4.47271 17.0667 4.83332V20.5764H6.90723V4.55048C6.90723 4.40906 6.93508 4.26903 6.9892 4.13837C7.04332 4.00772 7.12265 3.88901 7.22265 3.78901C7.32265 3.68902 7.44136 3.6097 7.57202 3.55559C7.70267 3.50147 7.84271 3.47363 7.98412 3.47363Z",
    stroke: "#7C4095",
    strokeWidth: 1.20362,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4146 6.82324H20.7629C21.0431 6.82324 21.3206 6.87843 21.5795 6.98567C21.8384 7.0929 22.0736 7.25007 22.2717 7.44821C22.4699 7.64635 22.627 7.88157 22.7343 8.14045C22.8415 8.39934 22.8967 8.6768 22.8967 8.95701V18.442C22.8967 18.7222 22.8415 18.9997 22.7343 19.2586C22.627 19.5175 22.4699 19.7527 22.2717 19.9508C22.0736 20.149 21.8384 20.3061 21.5795 20.4134C21.3206 20.5206 21.0431 20.5758 20.7629 20.5758H17.4146V6.82324Z",
    stroke: "#7C4095",
    strokeWidth: 1.20362,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3724 9.67871H22.3872C22.4344 9.67871 22.4795 9.69743 22.5129 9.73074C22.5462 9.76406 22.5649 9.80925 22.5649 9.85636V10.741C22.5649 10.7881 22.5462 10.8333 22.5129 10.8667C22.4795 10.9 22.4344 10.9187 22.3872 10.9187H19.3724C19.208 10.9187 19.0503 10.8534 18.934 10.7371C18.8178 10.6208 18.7524 10.4631 18.7524 10.2987C18.7524 10.1343 18.8178 9.97657 18.934 9.8603C19.0503 9.74403 19.208 9.67871 19.3724 9.67871Z",
    fill: "#7C4095"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3724 13.0801H22.3872C22.4344 13.0801 22.4795 13.0988 22.5129 13.1321C22.5462 13.1654 22.5649 13.2106 22.5649 13.2577V14.1424C22.5649 14.1895 22.5462 14.2347 22.5129 14.268C22.4795 14.3013 22.4344 14.32 22.3872 14.32H19.3724C19.208 14.32 19.0503 14.2547 18.934 14.1385C18.8178 14.0222 18.7524 13.8645 18.7524 13.7001C18.7524 13.5356 18.8178 13.3779 18.934 13.2617C19.0503 13.1454 19.208 13.0801 19.3724 13.0801Z",
    fill: "#7C4095"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.55811 20.5762H3.20973C2.92949 20.5762 2.652 20.521 2.39311 20.4137C2.13421 20.3065 1.89897 20.1493 1.70083 19.9511C1.50269 19.7529 1.34552 19.5177 1.2383 19.2588C1.13109 18.9999 1.07592 18.7224 1.07595 18.4421L1.07595 8.95739C1.07595 8.67717 1.13113 8.3997 1.23836 8.14082C1.34559 7.88193 1.50276 7.6467 1.7009 7.44855C1.89904 7.25041 2.13427 7.09323 2.39315 6.98599C2.65204 6.87876 2.92951 6.82356 3.20973 6.82356H6.55811L6.55811 20.5762Z",
    stroke: "#7C4095",
    strokeWidth: 1.20362,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.60023 10.9189H1.58542C1.5383 10.9189 1.49311 10.9002 1.4598 10.8669C1.42648 10.8336 1.40777 10.7884 1.40777 10.7413V9.85662C1.40777 9.80951 1.42648 9.76432 1.4598 9.73101C1.49311 9.69769 1.5383 9.67897 1.58542 9.67897H4.60023C4.68165 9.67897 4.76227 9.69501 4.83749 9.72617C4.91271 9.75733 4.98105 9.80299 5.03863 9.86056C5.0962 9.91814 5.14186 9.98648 5.17302 10.0617C5.20418 10.1369 5.22021 10.2175 5.22021 10.299C5.22021 10.4634 5.1549 10.6211 5.03863 10.7374C4.92236 10.8536 4.76466 10.9189 4.60023 10.9189Z",
    fill: "#7C4095"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.60023 14.3193H1.58542C1.5383 14.3193 1.49311 14.3006 1.4598 14.2673C1.42648 14.234 1.40777 14.1888 1.40777 14.1417V13.257C1.40777 13.2099 1.42648 13.1647 1.4598 13.1314C1.49311 13.0981 1.5383 13.0794 1.58542 13.0794H4.60023C4.76466 13.0794 4.92236 13.1447 5.03863 13.261C5.1549 13.3772 5.22021 13.5349 5.22021 13.6994C5.22021 13.8638 5.1549 14.0215 5.03863 14.1377C4.92236 14.254 4.76466 14.3193 4.60023 14.3193Z",
    fill: "#7C4095"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.791 6.4525H12.1826V6.5495H13.4407V5.9639C13.4407 5.73312 13.3491 5.51179 13.1859 5.34861C13.0227 5.18543 12.8014 5.09375 12.5706 5.09375H11.4103C11.2961 5.09373 11.1829 5.11622 11.0773 5.15994C10.9717 5.20366 10.8758 5.26775 10.795 5.34856C10.7141 5.42936 10.65 5.52529 10.6063 5.63087C10.5626 5.73645 10.54 5.84962 10.54 5.9639V6.5495H11.7909L11.791 6.4525Z",
    fill: "#7C4095",
    stroke: "#7C4095",
    strokeWidth: 0.00523314,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1826 9.54729H11.791V9.4502H10.54V10.0357C10.54 10.2665 10.6317 10.4879 10.7949 10.6511C10.9581 10.8143 11.1794 10.9059 11.4102 10.9059H12.5705C12.6848 10.9059 12.7979 10.8834 12.9035 10.8397C13.0091 10.796 13.105 10.7319 13.1858 10.6511C13.2666 10.5703 13.3307 10.4743 13.3744 10.3687C13.4181 10.2632 13.4406 10.15 13.4406 10.0357V9.4502H12.1826V9.54729Z",
    fill: "#7C4095",
    stroke: "#7C4095",
    strokeWidth: 0.00523314,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.026 6.5498H13.4404V7.8043H13.5338V8.19591H13.4404V9.4503H14.026C14.1403 9.4503 14.2535 9.42779 14.359 9.38406C14.4646 9.34033 14.5605 9.27623 14.6413 9.19542C14.7221 9.11461 14.7862 9.01868 14.83 8.91311C14.8737 8.80753 14.8962 8.69437 14.8962 8.5801V7.41995C14.8962 7.18918 14.8045 6.96785 14.6413 6.80467C14.4781 6.64148 14.2568 6.5498 14.026 6.5498Z",
    fill: "#7C4095",
    stroke: "#7C4095",
    strokeWidth: 0.00523314,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4396 8.19591V7.8043H10.5401V6.5498H9.95467C9.8404 6.5498 9.72724 6.5723 9.62167 6.61603C9.51609 6.65975 9.42016 6.72385 9.33935 6.80465C9.25855 6.88545 9.19445 6.98137 9.15071 7.08695C9.10698 7.19252 9.08447 7.30568 9.08447 7.41995V8.5802C9.0845 8.81098 9.17619 9.03229 9.33938 9.19546C9.50258 9.35863 9.7239 9.4503 9.95467 9.4503H10.5401V8.19591H10.4396Z",
    fill: "#7C4095",
    stroke: "#7C4095",
    strokeWidth: 0.00523314,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1826 7.65129C12.2473 7.68704 12.3008 7.74 12.3372 7.8043H13.4407V6.5498H12.1826V7.65129Z",
    fill: "#7C4095",
    stroke: "#7C4095",
    strokeWidth: 0.00523314,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6437 7.8043C11.6787 7.74248 11.7296 7.6911 11.791 7.65544V6.5498H10.54V7.8043H11.6437Z",
    fill: "#7C4095",
    stroke: "#7C4095",
    strokeWidth: 0.00523314,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.791 8.34412C11.7296 8.30848 11.6787 8.25712 11.6437 8.19531H10.54V9.4497H11.7909L11.791 8.34412Z",
    fill: "#7C4095",
    stroke: "#7C4095",
    strokeWidth: 0.00523314,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3372 8.19531C12.3008 8.25961 12.2473 8.31257 12.1826 8.34832V9.4497H13.4407V8.19531H12.3372Z",
    fill: "#7C4095",
    stroke: "#7C4095",
    strokeWidth: 0.00523314,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6766_20289"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.0138,
    height: 18.2957,
    fill: "white",
    transform: "translate(0.479492 2.87695)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacility);
export default __webpack_public_path__ + "static/media/facility.df787ccc33638bb2074f19d1b627fd2c.svg";
export { ForwardRef as ReactComponent };